
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAutomationButtonReadoutStack as ObcAutomationButtonReadoutStackElement} from '@oicl/openbridge-webcomponents/dist/components/automation-button-readout-stack/automation-button-readout-stack.js';
 
 
 

 
 export const ObcAutomationButtonReadoutStack = createComponent({
   react: React,
   tagName: 'obc-automation-button-readout-stack',
   elementClass: ObcAutomationButtonReadoutStackElement,
   events: {
     
   }
  });
 
 